import { render, staticRenderFns } from "./_emrEditor.vue?vue&type=template&id=4070c721"
import script from "./_emrEditor.vue?vue&type=script&lang=js"
export * from "./_emrEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports